import React from 'react';

const testIds = {
    CROSS_ICON: 'CROSS_ICON'
};

const CrossIcon = (props: any) => (
    <svg
        data-test-id={testIds.CROSS_ICON}
        {...props}
        viewBox="0 0 24 24"
        width={24}
        height={24}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M18.7091 6.71004L17.2891 5.29004L11.9991 10.59L6.70906 5.29004L5.28906 6.71004L10.5891 12L5.28906 17.29L6.70906 18.71L11.9991 13.41L17.2891 18.71L18.7091 17.29L13.4091 12L18.7091 6.71004Z"
            fill="#F9FAFA"
        />
    </svg>
);

export {CrossIcon};
